import { render } from "./activity-card.vue?vue&type=template&id=2ddf1c0c&ts=true"
import script from "./activity-card.vue?vue&type=script&lang=ts"
export * from "./activity-card.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__